import React, { useEffect, useState } from "react";
import { Modal, Button, Form, Input, Checkbox, Typography } from "antd";
import { FormattedMessage, useIntl } from "react-intl";
import { useSelector } from "react-redux";

const { TextArea } = Input;

function SendEmailModal(props) {
  const intl = useIntl();
  const clients = useSelector((state) => state.clients.clientListById);
  const partner = useSelector((state) => state.clients.partnerClientById);
  const companies = useSelector((state) => state.lookup.companyNames);
  const companyId = localStorage.getItem("CompanyId");
  const [companyName, setCompanyName] = useState("");

  useEffect(() => {
    const findCompany = companies.filter((com) => com.id == Number(companyId));
    setCompanyName(findCompany?.[0]?.companyName);
  }, [companies, companyId]);

  const isQuote = props.type === "quote";
  const isInvoice = props.type === "invoice";

  return (
    <Modal
      title={
        isQuote ? (
          <FormattedMessage id="Quote.Email.EmailQuote" />
        ) : (
          <FormattedMessage id="Invoice.Email.EmailInvoice" />
        )
      }
      width={800}
      open={props?.isOpen}
      onCancel={props?.onCancel}
      footer={[
        <Button key="cancel" onClick={props?.onCancel}>
          <FormattedMessage id="Common.Cancel" />
        </Button>,
        <Button key="send" type="primary" onClick={props?.onSend}>
          <FormattedMessage id="Common.Save" />
        </Button>,
      ]}
    >
      <Typography.Paragraph>
        {isQuote ? (
          <FormattedMessage id="Quote.Email.HeaderMessage" />
        ) : (
          <FormattedMessage id="Invoice.Email.HeaderMessage" />
        )}
      </Typography.Paragraph>

      <Form
        layout="horizontal"
        form={props?.form}
        size="large"
        colon={false}
        labelCol={{ span: 4 }}
        wrapperCol={{ span: 20 }}
        initialValues={{
          email: partner ? partner?.email : clients?.email,
          sendCopy: true,
          includedAttachment: isQuote,
          message: isQuote
            ? `Dear ${
                partner ? partner?.companyName : clients?.name
              },\n\nThank you for considering ${companyName}.`
            : `Dear ${
                partner ? partner?.companyName : clients?.name
              },\n\nPlease find attached your invoice from ${companyName}.`,
          subject: isQuote
            ? `${companyName} – Quotation`
            : `${companyName} – Invoice`,
        }}
      >
        <Form.Item
          label={<FormattedMessage id="Quote.Email.To" />}
          name="email"
          rules={[
            {
              required: true,
              message: intl.formatMessage({
                id: "Quote.Email.Error.PEnterYourEmail",
              }),
            },
            {
              validator: (_, value) => {
                if (!value) return Promise.resolve();

                const emails = value.split(",").map((e) => e.trim());
                const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

                const invalidEmails = emails.filter(
                  (email) => !emailRegex.test(email)
                );
                if (invalidEmails.length > 0) {
                  return Promise.reject(
                    intl.formatMessage({
                      id: "Lead.Rule.Email",
                    })
                  );
                }
                return Promise.resolve();
              },
            },
          ]}
        >
          <Input
            placeholder={intl.formatMessage({
              id: "Quote.Email.Placeholder.EnterYourEmail",
            })}
          />
        </Form.Item>

        <Form.Item
          label={<FormattedMessage id="Quote.Email.Cc" />}
          name="cc"
          rules={[
            {
              validator: (_, value) => {
                if (!value) return Promise.resolve();

                const emails = value.split(",").map((e) => e.trim());
                const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

                const invalidEmails = emails.filter(
                  (email) => !emailRegex.test(email)
                );
                if (invalidEmails.length > 0) {
                  return Promise.reject(
                    intl.formatMessage({
                      id: "Lead.Rule.Email",
                    })
                  );
                }
                return Promise.resolve();
              },
            },
          ]}
        >
          <Input
            placeholder={intl.formatMessage({
              id: "Quote.Email.Placeholder.EnterYourEmail",
            })}
          />
        </Form.Item>

        {isQuote && (
          <Form.Item
            label="&nbsp;"
            name="includedAttachment"
            valuePropName="checked"
          >
            <Checkbox>
              <FormattedMessage id="Quote.Email.IncludePdfAttachment" />
            </Checkbox>
          </Form.Item>
        )}

        <Form.Item
          label={<FormattedMessage id="Quote.Email.Subject" />}
          name="subject"
          rules={[
            {
              required: true,
              message: intl.formatMessage({
                id: "Quote.Email.Error.PEnterYourSubject",
              }),
            },
          ]}
        >
          <Input
            placeholder={intl.formatMessage({
              id: "Quote.Email.Placeholder.EnterYourSubject",
            })}
          />
        </Form.Item>

        <Form.Item
          label={<FormattedMessage id="Quote.Email.Message" />}
          name="message"
          rules={[
            {
              required: true,
              message: intl.formatMessage({
                id: "Quote.Email.Error.PEnterYourMessage",
              }),
            },
          ]}
        >
          <TextArea
            rows={9}
            placeholder={intl.formatMessage({
              id: "Quote.Email.Placeholder.EnterYourMessage",
            })}
          />
        </Form.Item>
      </Form>
    </Modal>
  );
}

export default SendEmailModal;
